<template>
  
    <div class="confer"  v-if="isShowCen" > 
              <div class="righetitels">
                会议、宴会、婚宴等活动提交-销售会尽快与您取得联系 <i @click="closewin" class="el-icon-close"></i>
              </div>
              <div class="contact">
                <ul>
                  <li>
                    <label>联系人</label>
                    <input
                      type="text"
                      class="puts"
                      name="name"
                      v-model="name"
                      placeholder="请输入联系人"
                    />
                  </li>
                  <li>
                    <label>手机号码</label>
                    <input
                      type="text"
                      class="puts"
                      name="phone"
                      v-model="phone"
                      placeholder="请输入手机号码"
                    />
                  </li>
                  <li>
                    <label
                      >特殊要求<span
                        >（选填）</span
                      ></label
                    >
                    <textarea
                      name="message"
                      class="message"
                      placeholder="请输入特殊要求"
                      :value="message"
                      @input="message = $event.target.value"
                    ></textarea>
                  </li>

                  <li>
                    <button
                      type="submit"
                      :disabled="isSubmitting"
                      :class="[buttonClass, { disabled: isSubmitting }]"
                      @click="submitForm"
                    >
                      提交信息
                    </button>
                  </li>
                </ul>
              </div>
              <div v-if="loading" class="loading">
            <!-- 显示加载图片 -->
            <span></span>
            <span></span>
            <span></span>
          </div>
            </div>
 
</template>
<script>
import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import menuTitle from "components/content/menuTitle";
import leftcheck from "components/content/Leftcheck";

import { UID } from "@/common/until/const";
import { setStorage, getStorage } from "@/common/until/until";
import { MessageBox  } from 'element-ui';
import { postHuiyiabc } from "network/confercence";
import { mapMutations } from "vuex";

export default {
  name: "Confer",
  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    menuTitle,
  },
  data() {
    return {
      righttitles: "在线酒店查询",
      lefttitles: "会议预定",
      name: "",
      phone: "",
      message: "",
      isSubmitting: false,
      buttonClass: "submit",
      loading: false, // 控制加载状态
      isshow:true
    };
  },
  mounted() {},
  updated() {},
  created() {},
  methods: {
    ...mapMutations(["updateIsShowCen"]),
    closewin() {
      this.updateIsShowCen(!this.$store.state.isshowcen);
    },
    submitForm() {
      const that = this;
      if (this.isSubmitting) {
        this.$message.error("请勿提交");
        return; // 正在提交时，不执行重复提交操作
      }

      if (!this.name) {
        // 使用 Element UI 弹窗提示错误
        this.$message.error("请输入姓名");
        return;
      }

      // 正则验证手机号
      const phoneRegex = /^1[3456789]\d{9}$/;
      if (!phoneRegex.test(this.phone)) {
        // 使用 Element UI 弹窗提示错误
        this.$message.error("请输入有效的手机号码");

        return;
      }
      if (!this.phone) {
        // 使用 Element UI 弹窗提示错误
        this.$message.error("请输入手机号");
        return;
      }
      this.isSubmitting = true; // 开始提交
      this.buttonClass = "submitting"; // 设置正在提交的 CSS 类
      const params = {
        zid: this.$route.query.hid || getStorage("cachedId") || "",
        uid: UID,
        guest: this.name,
        tel: this.phone,
        xiangxishuoming: this.message,
        a: 'addhuiyi',
      };
      this.loading = true;

      postHuiyiabc(params)
        .then((response) => {
          that.loading = true;
          if (response.success ) {
            this.loading = false;
            this.buttonClass = "submitting"; // 提交成功后禁用按钮
            this.isSubmitting = true; // 提交成功后禁用按钮
            this.name = null;
            this.phone = null;
            this.message = null;
            MessageBox.alert('提交成功', '提示', {
        confirmButtonText: '确定',
        type: 'info'
      }).then(() => {
        // 用户点击确定按钮后执行的函数
        that.isSubmitting = false; // 提交成功后禁用按钮
        this.isLoading = false;
        this.buttonClass = "submit"; // 提交成功后禁用按钮
      });
          } else {
            this.$message.error("提交失败");
            this.isLoading = false;
            that.isSubmitting = false; // 提交成功后禁用按钮
            this.buttonClass = "submit"; // 提交成功后禁用按钮
          }
        })
        .catch((error) => {
          // 处理错误
          // console.error("Error:", error);
          this.$message.error("提交失败");
        });
    },
  },
  computed: { isShowCen() {
      return this.$store.state.isshowcen;
    }},
};
</script>
<style lang="less" scoped>


.loading {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  span {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: #3498db;
    border-radius: 50%;
    opacity: 0;
    animation: scale 1s ease-in-out infinite;
    animation-delay: 0s, 0.25s, 0.5s; /* 每个元素延迟不同的时间 */
    margin: 0 5px;
  }

  @keyframes scale {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.3;
      transform: scale(0.5);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
}

.confer {
  position: relative;
  .confertips {
    width: 330px;
  
 
    line-height: 21px;
    background: #faffe0;
    border-radius: 8px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    color: #555;
    img {
      margin-right: 10px;
    }
  }
  ul {
    li {
      margin-bottom: 20px;
      padding: 0 20px;
    }
  }
  label {
    display: block;
    line-height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #180808;
    span {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff5555;
    }
  }
  .puts {
    width:280px;
    height:30px;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    text-indent: 10px;
  }
  .message {
    width: 280px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    text-indent: 10px;
  }
  .submit {
    width: 140px;
    height: 40px;
    background: #ff5555;
    border-radius: 8px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fffcfc;
  }
  .submitting {
    width: 160px;
    height: 50px;
    background: #ddd;
    border-radius: 8px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #888;
  }
  .righetitels{
    font-size: 12px;
    padding: 10px 20px;
    color: #f60;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i{
      cursor: pointer;
      margin-right: -10px;
    }
  }
}

@media (min-width: 320px) and (max-width: 780px) { 

  .confer {  
    display: none;

 } }
</style>
